import { injectable, injectFromBase } from 'inversify'
import OrmApiRepository from '@/data/repositories/ormApiRepository'
import type BaseModel from '@/data/models/BaseModel'

@injectable()
@injectFromBase()
export default class SmsRepository<T extends BaseModel = BaseModel> extends OrmApiRepository<T> {}
